module.exports = __webpack_public_path__ + "assets/img/3e605c98cda910053bc64e3aab2a3d40.png";